import { render, staticRenderFns } from "./News.vue?vue&type=template&id=1c8a4e14&scoped=true&"
import script from "./News.vue?vue&type=script&lang=js&"
export * from "./News.vue?vue&type=script&lang=js&"
import style0 from "../../less/activity.less?vue&type=style&index=0&id=1c8a4e14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8a4e14",
  null
  
)

export default component.exports